import React, { Fragment, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import useRequests from "../../../utils/useRequests";
import Snackbars from "../../../utils/Snackbars";
// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

const OrganizerProfile = () => {
    const navigate = useNavigate();
    const {postRequest, getRequest} = useRequests(); 
    const [formData, setFormData] = useState({
        fullName:" ",
        email:"",
        // fullName: "Ramanuj Jignesh ",
        // email: "jignesh@mxicoders.com",
        // location: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    });

     const [AlertData, setAlertData] = React.useState({
            variant: '',
            message: '',
        });
        const resetAlertData = () => {
            setTimeout(() => {
                setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: '',
                    message: '',
                }));
            }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
        };
        const [loading, setLoading] = useState(true);
        const fetchOrganizerData = async () => {
            try {
                const response = await getRequest(`/organizer-data`);
                if (response && Array.isArray(response.data) && response.data.length > 0) {
                    // Access the first element of the data array
                    const { first_name = "", last_name = "", email=""  } = response.data[0];
                    const fullName = `${first_name} ${last_name}` .trim();
                    setFormData({fullName, email});
                } else {
                    console.error("No user data found in the response.");
                }
                setLoading(false);
            } catch (error) {
                console.error("Error fetching user data:", error);
                setLoading(false);
            }
        };
  useEffect(() => {
        fetchOrganizerData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const validation1 = useFormik({
        enableReinitialize: true,
    
        initialValues: formData,

        validationSchema: Yup.object({
            fullName: Yup.string().required('Full name is required'),
          email: Yup.string()
            .email('Please enter a valid email!')
            .max(255)
            .required('Email is required'),
          
        }),
       onSubmit:  async (values) => {
        // e.preventDefault();
        try {
            let submit1 = document.getElementById('submit1');
            submit1.disabled = true;
            submit1.textContent = ('Processing...');

            const jsonpar = JSON.stringify({
                fullname: values.fullName,
                email: values.email,
                
            });

            const res = await postRequest("update-profile", jsonpar);
            if (res && res.code === 200) {
                localStorage.setItem('organizerName', JSON.stringify(values.fullName));

                setAlertData({
                    variant: "success",
                    message: "Profile updated successfully!",
                });
                resetAlertData();
                navigate('/dashboard',{
                    state:{ variant: "success",
                        message: "Profile updated successfully!",}
                })
            } else {
                setAlertData({
                    variant: "error",
                    message: res.message || "Failed to update profile.",
                });
                resetAlertData();
            }
            submit1.disabled = false;
            submit1.textContent = ('Update Profile');
        } catch (error) {
            console.error("Error: ", error);
            setAlertData({
                variant: "error",
                message: "An error occurred while updating the profile.",
            });
            resetAlertData();
        }
    }
    });
    if (loading) return <p>Loading...</p>;
    return (
        <Fragment>
            <div className="d-sm-flex d-block justify-content-between align-items-center mb-4">
                <h2 className="text-black font-w700 mb-0">Organizer Profile</h2>
            </div>

            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="basic-form">
                            {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
                            <form >
                                <div className="row mb-3">
                                    <div className="form-group mb-3 col-md-6">
                                        <label>Full Name :</label>
                                        <input
                                            type="text"
                                            name="fullName"
                                            placeholder="Please Enter Full Name"
                                            className={`form-control ${validation1.touched.fullName && validation1.errors.fullName ? 'is-invalid' : ''}`}
                                            value={validation1.values.fullName || ""}
                                            onChange={validation1.handleChange}
                                            onBlur={validation1.handleBlur}
                                            invalid={
                                              validation1.touched.fullName && validation1.errors.fullName ? true : false
                                            }
                                                            
                                          />
                                          {validation1.touched.fullName && validation1.errors.fullName ? (
                                            <div className="invalid-feedback" >{validation1.errors.fullName}</div>
                                          ) : null}
                                    </div>
                                    <div className="form-group mb-3 col-md-6">
                                        <label>Email ID :</label>
                                        <input
                                            type="text"
                                            name="email"
                                            placeholder="Please Enter Email"
                                            className={`form-control ${validation1.touched.email && validation1.errors.email ? 'is-invalid' : ''}`}
                                            value={validation1.values.email || ""}
                                            onChange={validation1.handleChange}
                                            onBlur={validation1.handleBlur}
                                            invalid={
                                              validation1.touched.email && validation1.errors.email ? true : false
                                            }
                                            
                                          />
                                          {validation1.touched.email && validation1.errors.email ? (
                                            <div className="invalid-feedback" >{validation1.errors.email}</div>
                                          ) : null}
                                    </div>
                                    
                                </div>
                                <button type="submit" className="btn btn-primary me-2"
                                id="submit1"
                                onClick={(e) => {
                                    e.preventDefault();
                                    validation1.handleSubmit();
                                    return false;
                                  }}>
                                    {('Update Profile')}
                                </button>
                                <Link to="/dashboard" className="btn btn-light">
                                    Cancel
                                </Link>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default OrganizerProfile;
